<div class="cus-field-group">
  <input name="inputValueField" type="text" class="form-control" pInputText [(ngModel)]="accountInputValue"
    (focusout)="checkValueIfExist()" #inputValue="ngModel" />
    <i class="fa fa-search cus-field more-option" aria-hidden="true" (click)="openAccountsModal($event)"></i>
  </div>
  @if (errorMessage) {
    <small class="text-danger">
      {{errorMessage}}
    </small>
  }
  @if (displayAccountPopup) {
    <app-linked-account-popup [displaySearchDialog]="displayAccountPopup"
      (onSubmit)="addAccount($event)" (onCancel)="clearSelectedAccount()" [selectedLinkedAccount]="selectedAccount"
      [loadAccount]="loadAccount" [allowSelectAccountType]="allowSelectAccountType" [kindOfAccountType]="1">
    </app-linked-account-popup>
  }